<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Nuevo rol</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/" >
                            <span>Dashboard</span>
                        </router-link>
                    </li> 

                    <li class="breadcrumb-item active">
                        <router-link to="/Roles" >
                            <span>Roles</span>
                        </router-link>
                    </li> 

                    <li class="breadcrumb-item active">Nuevo Rol</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">
            <RoleManagerComponent type="C" />
        </section>
    </MainLayout>
</template>

<script>
import MainLayout from '../../../layouts/MainLayout';
import RoleManagerComponent from '@/components/Admin/Roles/RoleManagerComponent.vue';

export default {


    name: 'CreateRole',

    components: {
        MainLayout,
        RoleManagerComponent,
    },
};
</script>